<div class="mask-cover" [style.z-index]="showLoading ? 3 : 1">
  <mat-spinner *ngIf="showLoading"></mat-spinner>
</div>
